import React from 'react';
import NavLink from './NavLink';
import { NavItem } from '../layout/Header';

/**
 * Props for the MainNav component
 */
interface MainNavProps {
  /** Array of navigation items to display */
  navItems: NavItem[];
}

/**
 * Main navigation component for desktop view
 */
const MainNav: React.FC<MainNavProps> = ({ navItems }) => {
  return (
    <nav className="hidden md:flex items-center space-x-6">
      {navItems.map((item, index) => (
        <NavLink 
          key={index} 
          href={item.href} 
          external={item.external}
          onClick={item.onClick}
          isButton={item.isButton}
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
};

export default MainNav;

